import { API } from "../../Services";

export const downlineAdmins = (query='') =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_DOWN_ADMIN_LIST",
        })
         API.downlineAdmins(query).then((res)=>{
            let data = JSON.parse(JSON.stringify(res)).data.admins
            data.map((admin,adminIndex)=>{
                admin.value = admin.admin_id
                admin.label = `${admin.admin_firstname} ${admin.admin_lastname}`
            })
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_DOWN_ADMIN_LIST",
                    payload:data,
                })
            },1000)
        }).catch((err)=>{
            dispatch({
                type:"ERROR_DOWN_ADMIN_LIST",
            })
        })
    }
}